import images from "@assets/images";
import { useNavigation } from "@react-navigation/native";
import { DimensionContext } from "@src/DimensionProvider";
import { ImageButton } from "components/button";
import React from "react";

const Ball = () => {
  const navigation = useNavigation<any>();
  const { hudHeight } = React.useContext(DimensionContext);

  return (
    <ImageButton
      source={{uri: images.btn_ball}}
      onPress={() => navigation.navigate("GoldenBall")}
      style={[{ width: hudHeight * 0.95, height: hudHeight * 0.83, bottom: "6%" }]}
    />
  );
};

export default React.memo(Ball);
